// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPatientModel } from './eServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPatientModel.js';
import type { EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberModel } from './eServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description MedicalCardFinderRequestModel
*/
export class EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderRequestModel {
    'patient': EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPatientModel | null;
    'prescriber': EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberModel | null;
    /**
    * @description Project
    */
    'project'?: string | null;
    /**
    * @description QuickPath Case Id
    */
    'quickPathCaseId'?: number | null;
    /**
    * @description Client Id 1
    */
    'clientId1'?: string | null;
    /**
    * @description Client Id 2
    */
    'clientId2'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderRequestModel>> = [
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPatientModel"
        },
        {
            "name":     "prescriber",
            "baseName": "prescriber",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberModel"
        },
        {
            "name":     "project",
            "baseName": "project",
            "type":     "string"
        },
        {
            "name":     "quickPathCaseId",
            "baseName": "quickPathCaseId",
            "type":     "number"
        },
        {
            "name":     "clientId1",
            "baseName": "clientId1",
            "type":     "string"
        },
        {
            "name":     "clientId2",
            "baseName": "clientId2",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderRequestModel.attributeTypeMap;
    }
}
